<p-dialog
  #fastPortador
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar portador</span>
      <i class="pi pi-fw pi-money-bill ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row m-0 p-2">
    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input
          matInput
          type="text"
          (blur)="actionFnCheckEntityExist(form.get('descricao'))"
          [formControl]="form.get('descricao')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('duplicate')
        "
      >
        Já existe um portador com essa descrição!
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('required')
        "
      >
        A descrição é obrigatória
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('maxlength')
        "
      >
        A descrição deve conter até 100 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('descricao').touched &&
          form.get('descricao').hasError('isEmptyValue')
        "
      >
        Inválido: remova os espaços em branco!
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Nome do banco</mat-label>
        <input matInput type="text" [formControl]="form.get('nome_banco')" />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('nome_banco').touched &&
          form.get('nome_banco').hasError('maxlength')
        "
      >
        Não pode ter mais que 100 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('nome_banco').touched &&
          form.get('nome_banco').hasError('isEmptyValue')
        "
      >
        Inválido: remova os espaços em branco!
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Nº da conta</mat-label>
        <input
          matInput
          type="text"
          style="text-align: right"
          (keydown)="validateOnlyNumbers($event)"
          [formControl]="form.get('numero_conta')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('numero_conta').touched &&
          form.get('numero_conta').hasError('maxlength')
        "
      >
        Até 20 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('numero_conta').touched &&
          form.get('numero_conta').hasError('existSpecialChar')
        "
      >
        Valor inválido, não aceita pontuação!
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Cód. do banco</mat-label>
        <input
          matInput
          type="text"
          style="text-align: right"
          [mask]="'000'"
          (keydown)="validateOnlyNumbers($event)"
          [formControl]="form.get('codigo_banco')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('codigo_banco').touched &&
          form.get('codigo_banco').hasError('maxlength')
        "
      >
        Até 3 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('codigo_banco').touched &&
          form.get('codigo_banco').hasError('existSpecialChar')
        "
      >
        Valor inválido, não aceita pontuação!
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Dígito da conta</mat-label>
        <input
          matInput
          type="text"
          style="text-align: right"
          [mask]="'0'"
          [formControl]="form.get('digito_conta')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('digito_conta').touched &&
          form.get('digito_conta').hasError('existSpecialChar')
        "
      >
        Valor inválido, não aceita pontuação!
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Cód. da agência</mat-label>
        <input
          matInput
          style="text-align: right"
          (keydown)="validateOnlyNumbers($event)"
          type="text"
          [formControl]="form.get('codigo_agencia')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('codigo_agencia').touched &&
          form.get('codigo_agencia').hasError('maxlength')
        "
      >
        Até 20 caracteres
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('codigo_agencia').touched &&
          form.get('codigo_agencia').hasError('existSpecialChar')
        "
      >
        Valor inválido, não aceita pontuação!
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Dígito da agência</mat-label>
        <input
          matInput
          type="text"
          [mask]="'0'"
          style="text-align: right"
          [formControl]="form.get('digito_agencia')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('digito_agencia').touched &&
          form.get('digito_agencia').hasError('existSpecialChar')
        "
      >
        Valor inválido, não aceita pontuação!
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Saldo inicial</mat-label>
        <input
          matInput
          (keydown)="validateNumbers($event)"
          [formControl]="form.get('saldo_inicial')"
          type="text"
          id="saldo-inicial"
          style="text-align: right;"
        />
        <span matPrefix *ngIf="form.get('saldo_inicial').value">R$&nbsp;</span>
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('required')
        "
      >
        Valor é obrigatório!
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('valueMinZero')
        "
      >
        Valor náo pode ser zero.
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('max_value')
        "
      >
        Inválido: passou dos limites
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('value_equals')
        "
      >
        Valor não pode ser igual ao atual
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('before_split')
        "
      >
        Inválido: erro na parte inteira
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('after_split')
        "
      >
        nválido: erro na parte decimal
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('errorComma')
        "
      >
        Inválido: excesso de vírgulas
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('errorDots')
        "
      >
        Inválido: excesso de pontos
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('invalidNumber')
        "
      >
        Valor inválido
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('existSpecialChar')
        "
      >
        Valor inválido, não aceita pontuação!
      </small>
      <small
        class="p-error"
        *ngIf="
          form.get('saldo_inicial').touched &&
          form.get('saldo_inicial').hasError('notNumbers')
        "
      >
        Inválido: insira um número
      </small>
    </div>
    <div class="col-md-3 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Saldo atual</mat-label>
        <input
          matInput
          (keydown)="validateNumbers($event)"
          [formControl]="form.get('saldo')"
          type="text"
          id="saldo-inicial"
          [readonly]="true"
          style="text-align: right;"
        />
        <span matPrefix *ngIf="form.get('saldo').value">R$&nbsp;</span>
      </mat-form-field>
    </div>
    <div class="col-md-3 mt-3" style="margin-top: 0.7rem !important;">
      <span class="p-float-label">
        <p-dropdown
          [(ngModel)]="form.value.tipo"
          [formControl]="form.get('tipo')"
          [options]="tipoPortador"
          optionLabel="viewValue"
          id="select-tipo"
        >
        </p-dropdown>
        <label for="float-input">Tipo *</label>
      </span>
      <small
        class="p-error"
        *ngIf="
          form.get('tipo').touched && form.get('tipo').hasError('required')
        "
      >
        Tipo é obrigatório
      </small>
    </div>
    <mat-checkbox
      *ngIf="!defaultExists"
      color="primary"
      class="col-md-4 mt-3"
      [formControl]="form.get('padrao')"
    >
      Portador padrão
    </mat-checkbox>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        mat-dialog-close
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
        [disabled]="loading"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="!form.valid || loading"
      ></button>
    </div>
  </ng-template>
</p-dialog>
